import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "plan-info" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

import { toRefs, computed } from 'vue';
import { addImageScaler, formatPrice } from '@/core';
import type { Elevation } from '@/types/elevations';
import LazyImage from './LazyImage.vue';
import ExteriorCardSkeleton from './ExteriorCardSkeleton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExteriorOptions',
  props: {
    elevations: {},
    loading: { type: Boolean },
    error: {},
    selected: {},
    planName: {},
    hasAvailableLots: { type: Boolean },
    planPriceLowWithPremium: {}
  },
  emits: ['update:selected'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const {
  elevations,
  loading,
  error,
  selected,
  planName,
  hasAvailableLots,
  planPriceLowWithPremium,
} = toRefs(props);
const emit = __emit;

// Mirror the sidebar plan card (SideBarPlanListItem.vue), which shows the price only when
// the plan-level `price_low_with_premium` is > 0 (its `>= 0` render gate combined with the
// truthy check on the price). This is the same plan object the sidebar uses, so a plan the
// sidebar marks "Price not available at this time" hides the price here too. Individual
// elevations are gated separately on their own `price` in the template.
const planHasPrice = computed(() => (planPriceLowWithPremium.value ?? 0) > 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(ExteriorCardSkeleton)
        ]))
      : (_unref(error))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(error)), 1))
        : (_unref(elevations).length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No elevations available."))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_unref(elevations), (elevation, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: elevation.elevation,
                class: _normalizeClass(["plan-card", { selected: _unref(selected) === idx }]),
                onClick: ($event: any) => (_ctx.$emit('update:selected', idx))
              }, [
                _createVNode(LazyImage, {
                  src: _unref(addImageScaler)(elevation.images[0]?.asset_value ?? ''),
                  alt: elevation.images[0]?.alt_tag || _unref(planName),
                  isNeighborhoodImage: false
                }, null, 8, ["src", "alt"]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h3", null, _toDisplayString(_unref(planName)) + " " + _toDisplayString(elevation.elevation), 1),
                  (_unref(hasAvailableLots) && planHasPrice.value && elevation.price > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "plan-info-label" }, "Starts at ", -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(elevation.price)), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("span", { class: "plan-info-label" }, "Price not available at this time", -1)
                      ]))]))
                ])
              ], 10, _hoisted_4))
            }), 128))
  ]))
}
}

})